import enLang from './entries/en-US';

const AppLocale = {
  en_US: enLang,
};

export default AppLocale;
